/** Title and description of this filter, for the builder next to `SALES_ITEM_CATEGORY_OPTIONS`. */
export const SALES_ITEM_CATEGORY_FILTER_TEXT = {
  title: 'Product categories',
  description: 'Filter by the category of the product (e.g. tire, service, add-on)'
};
